import axiosAutoCheck from "global/helpers/axiosAutoCheckIn";
import { GET_TEXTOS, GET_TEXTOS_FAIL, GET_TEXTOS_SUCCESS } from "../ActionTypes";

export const wsGetTextosCheckIn = () => (dispatch) => {
    dispatch({type: GET_TEXTOS}); 

    axiosAutoCheck().then(respuesta => {
        respuesta 
        .get('/Texto/GetAutoCheckin')
        .then(resp => dispatch({type: GET_TEXTOS_SUCCESS, payload: resp.data}))
        .catch(err => dispatch({type: GET_TEXTOS_FAIL, payload: err}))
    })
}


